import Service from './service'
export var ApiKeyboardMessageType;
(function (ApiKeyboardMessageType) {
  ApiKeyboardMessageType["KEYBOARD_CONTROL_REQUEST"] = "keyboard.control.request"
  ApiKeyboardMessageType["KEYBOARD_CONTROL_RESPONSE"] = "keyboard.control.response"
})(ApiKeyboardMessageType || (ApiKeyboardMessageType = {}))
export var KeyboardMessageType;
(function (KeyboardMessageType) {
  KeyboardMessageType["KEYBOARD_VISIBLE_CHANGE"] = "KEYBOARD_VISIBLE_CHANGE"
})(KeyboardMessageType || (KeyboardMessageType = {}))
/**
 * Сервис для работы с экранной клавиатурой
 * @version 0.0.1
 * @since 1.9.0
 */
export default class KeyboardService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiKeyboardMessageType.KEYBOARD_CONTROL_RESPONSE:
          if (typeof message.is_visible !== 'undefined') {
            this.broadcast(KeyboardMessageType.KEYBOARD_VISIBLE_CHANGE, message.is_visible)
          }
          else if (typeof message.locale !== 'undefined') {
            this.resolve(this.waiters.locale, message.locale)
          }
          break
      }
    }
    this.waiters = {
      locale: [],
    }
    this.messageChannel.subscribe(ApiKeyboardMessageType.KEYBOARD_CONTROL_RESPONSE, messageHandler)
  }
  /**
     * Сервис сообщил о видимости клавиатуры
     *
     * @since 1.9.0
     * @param {(isVisible: boolean) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof KeyboardService
     *
     * @example <caption>Сервис сообщил о видимости клавиатуры</caption>
     * robot.keyboardService.onChangeVisible((isVisible) => {
     *   ...
     * })
     */
  onChangeVisible(callback) {
    return this.subscribe(KeyboardMessageType.KEYBOARD_VISIBLE_CHANGE, callback)
  }
  /**
     * Установить язык
     *
     * @since 1.9.0
     * @param {string} locale - язык в форме "language_country", где language - строчное двухбуквенное представление
     * языкового кода в формате ISO-639, и country - Заглавное, двух- или трёх-буквенное представление кода страны в формате ISO-3166
     * Например: en_US, ru_RU
     *
     * @memberof KeyboardService
     *
     * @example <caption>Установить язык</caption>
     * robot.keyboardService.setLocale(locale)
     */
  setLocale(locale) {
    this.messageChannel.send({
      type: ApiKeyboardMessageType.KEYBOARD_CONTROL_REQUEST,
      set_locale: locale,
    })
  }
  /**
     * Получить текущий язык
     *
     * @since 1.9.0
     * @return {*}  {Promise<string>}
     * @memberof KeyboardService
     *
     * @example <caption>Получить текущий язык</caption>
     * robot.keyboardService.getLocale().then((locale) => {
     * })
     */
  getLocale() {
    return this.execute({
      type: ApiKeyboardMessageType.KEYBOARD_CONTROL_REQUEST,
      get_locale: '',
    }, this.waiters.locale)
  }
  /**
     * Принудительно показать клавиатуру
     *
     * Так же клавиатура автоматически показывается при onFocus на input
     *
     * @since 1.9.0
     * @memberof KeyboardService
     *
     * @example <caption>Показать клавиатуру</caption>
     * robot.keyboardService.show()
     */
  show() {
    this.messageChannel.send({
      type: ApiKeyboardMessageType.KEYBOARD_CONTROL_REQUEST,
      show: '',
    })
  }
  /**
     * Принудительно скрыть клавиатуру
     *
     * Так же клавиатура автоматически скрывается при onBlur на input
     *
     * @since 1.9.0
     * @memberof KeyboardService
     *
     * @example <caption>Скрыть клавиатуру</caption>
     * robot.keyboardService.hide()
     */
  hide() {
    this.messageChannel.send({
      type: ApiKeyboardMessageType.KEYBOARD_CONTROL_REQUEST,
      hide: '',
    })
  }
}
